import { Grid } from "@mui/material";
import MxModalTemplate2 from "@rf-l1/modal/MxModalTemplate2";
import MxTypography from "@rf-l1/MxTypography";
import useModal from "@rf/base/modal/useModal";

const useShowValidationInfo = () => {
  const { modal } = useModal();
  const showNotification = (
    message: string,
    status: "warning" | "approved" | "rejected"
    // url: string
  ) => {
    if (status === "approved") {
      return;
    }
    modal({
      data: {
        message,
        status
        // url
      },
      template: <MxModalTemplate2 children={<Template />} />,
      options: {
        style: {
          width: "100%",
          maxWidth: "400px",
          height: "300px"
        }
      }
    });
  };
  return {
    showNotification
  };
};

export default useShowValidationInfo;

const Template = () => {
  const { getData } = useModal();
  const data = getData() as {
    message: string;
    status: "warning" | "approved" | "rejected";
    url: string;
  };

  return (
    <Grid container rowGap={2}>
      <Grid item xs={12}>
        <MxTypography variant="subtitle2" color="primary.main" fontWeight={500}>
          {data.status === "warning" && "Este documento tiene una advertencia"}
          {data.status === "rejected" &&
            "Este documento ha sido rechazado debido a: "}
          {data.status === "approved" && "Este documento ha sido aprobado"}
        </MxTypography>
      </Grid>
      <Grid item xs={12}>
        <MxTypography variant="body2" color="grey.500" fontWeight={500}>
          {data.message}
        </MxTypography>
      </Grid>
    </Grid>
  );
};
